/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */
import TableMosaicTransactions from '../views/components/TableMosaicTransactions';

import TableHolders from '../views/Transactions/components/TableHolders';
import TableTransactions from '../views/components/TableTransactions';

export default [
  // Settings
  {
    path: '/',
    name: 'main.index',
    component: () => import('@/views/Main/Index.vue')
  },
  {
    path: '/transactions/:id',
    name: 'transactions.index',
    component: () => import('@/views/Transactions/Index.vue'),
    children: [
      {
        path: 'tx/:num',
        name: "tx.table",
        component: TableTransactions
      },
      {
        path: 'holders/:num',
        name: "tx.holders",
        component: TableHolders
      }
    ]
  },
  {
    path: '/tx/:hash',
    name: 'tx.index',
    component: () => import('@/views/Detail/TxDetail.vue')
  },
  {
    path: '/address/:hash',
    name: 'address.index',
    component: () => import('@/views/Detail/AccountDetail.vue'),
    children: [
      {
        path: 'tx/:num',
        name: "tx.address.table",
        component: TableMosaicTransactions
      }
    ]
  },
  {
    path: '/address/:hash',
    name: 'address.index',
    component: () => import('@/views/Detail/AccountDetail.vue')
  },
  {
    path: '/404',
    name: 'not_found.index',
    component: () => import('@/views/components/NotFound.vue')
  },
];
